module.exports = __webpack_public_path__ + "static/banner-1965f0f443ab12689460446c870dbc9f.jpg";